interface BetaSignupProps {
  heading: string;
  content: string;
  cta: {
    text: string;
    url: string;
  };
}

export default function BetaSignup({ heading, content, cta }: BetaSignupProps) {
  return (
    <div className="py-20 bg-gradient-to-r from-blue-600 to-purple-700 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-6">{heading}</h2>
        <p className="text-lg mb-10 text-blue-50">{content}</p>
        <a
          href={cta.url}
          className="inline-block px-8 py-4 bg-white text-blue-600 font-bold text-lg rounded-lg hover:bg-gray-100 transition shadow-lg"
        >
          {cta.text}
        </a>
      </div>
    </div>
  );
}
